import React, { useState } from "react";
import OfficerListing from "../offers/recommendations/listing";

/**
 * RecommendationsTab — thin wrapper around the existing OfficerListing.
 * When the user creates an offer from a recommendation, jump to Sent Offers.
 */
const RecommendationsTab = ({
  providerCompanyId,
  jobId,
  setOfficersCount,
  officersCount,
  fetchJobAndOfferMetadata,
  goToOffers,
}) => {
  const [listViewType, setListViewType] = useState("recommended");
  const [, setSelectedOfferId] = useState(null);

  const handleTabChange = (key) => {
    // Legacy hook from OfficerListing — when it asks us to switch to
    // the offers tab ("2") after creating an offer, route to Sent Offers.
    if (key === "2" && goToOffers) goToOffers();
  };

  return (
    <div className="h-full">
      <OfficerListing
        providerCompanyId={providerCompanyId}
        jobId={jobId}
        listViewType={listViewType}
        setListViewType={setListViewType}
        setSelectedOfferId={setSelectedOfferId}
        handleTabChange={handleTabChange}
        setActiveTab={handleTabChange}
        setOfficersCount={setOfficersCount}
        officersCount={officersCount}
        fetchJobAndOfferMetadata={fetchJobAndOfferMetadata}
      />
    </div>
  );
};

export default RecommendationsTab;
